import { Image, Color, GiftcardProduct, DonationProduct } from './apiTypes';

export enum ProductListItemType {
  DonationProduct = 'DonationProduct',
  GiftcardProduct = 'GiftcardProduct',
  TopProduct = 'TopProduct',
}

export type ProductListItem = {
  backgroundColor: Color | null;
  backgroundImage: Image | null;
  cardImage: Image | null;
  description: string | null;
  id: string | null;
  path: string | null;
  product: GiftcardProduct | DonationProduct | null;
  showHand: boolean;
  title: string;
  type: ProductListItemType;
};
